<template>
  <div class="breadcrumbs">

    <div class="item" v-for="(item, key) in navigationData" :key="key">

      <span
          @click="function() {
            if(key != navigationData.length - 1) {
              $router.push({ name: item.route, params : {section: item.code, tab: 'main'} })
            }
          }"
          :class="[{active: key == navigationData.length - 1}]"
          v-html="item.name"
      ></span>

      <svg v-show="key != navigationData.length - 1" xmlns="http://www.w3.org/2000/svg" width="5" height="18" viewBox="0 0 5 18" fill="none">
        <g clip-path="url(#clip0_60_4285)">
          <path d="M5 9L0 12L2.52368e-07 6L5 9Z" fill="#656565"/>
        </g>
        <defs>
          <clipPath id="clip0_60_4285">
            <rect width="18" height="5" fill="white" transform="matrix(-4.37114e-08 1 1 4.37114e-08 0 0)"/>
          </clipPath>
        </defs>
      </svg>

    </div>

  </div>
</template>

<script>

export default {
  name : "BreadCrumbs",
  props : {
    navigationData : Array
  },
  data() {
    return{

    }
  },
  mounted() {

  }
}
</script>

<style scoped>

.breadcrumbs {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.breadcrumbs .item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.breadcrumbs span{
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  cursor: pointer;
}

.breadcrumbs span.active{
  color: var(--Blue, #1B78BC);
  cursor: unset;
}

.breadcrumbs svg{

}



/*MOBILE*/
@media (max-width: 1250px)
{
  .breadcrumbs {
    flex-wrap: wrap;
  }
}

</style>